import { render, staticRenderFns } from "./CreateServiceRequestCard.vue?vue&type=template&id=4c37a674&"
import script from "./CreateServiceRequestCard.vue?vue&type=script&lang=js&"
export * from "./CreateServiceRequestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports